import { Component } from '@angular/core';
import { VariableDetails } from '../../shared/ontology/model/variable-details';
import { VariableValidationService, VariableValidationStatusType } from '../../shared/ontology/service/variable-validation.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-lot-import-descriptors-confirmation-dialog',
    templateUrl: './lot-import-update-descriptors-confirmation-dialog.component.html'
})
export class LotImportUpdateDescriptorsConfirmationDialogComponent {
    attributeStatusById: { [key: number]: VariableValidationStatusType; } = {};
    attributes: VariableDetails[] = [];

    constructor(
        private variableValidationService: VariableValidationService,
        private modal: NgbActiveModal
    ) {
    }

    getStatusIcon(attribute) {
        return this.variableValidationService.getStatusIcon(attribute, this.attributeStatusById);
    }

    dismiss() {
        this.modal.dismiss();
    }

    confirm() {
        this.modal.close();
    }
}
